export default {
    is_away: 'is away',
    is_broadcasting: 'is broadcasting',
    is_offline: 'is offline',
    is_online: 'is online',
    no_alerts: 'No Alerts',
    no_history: 'No History',
    no_search_results: 'No items in history match your search of',
    see_alerts: 'see alerts',
    isPublicShow: 'is in Public Chat',
    isTruePrivate: 'is in a TruePrivate',
    isOnlyPrivate: 'is in Private Chat',
    isGroupShow: 'is in a Group Show',
    isClubShow: 'is in a Club Show',
    isBroadcasting: 'is broadcasting',
    isOnline: 'has signed in',
    newsUpdate: 'posted news',
    newsUpdateVerbose: 'posted a news update',
}
